function initCjiStories() {
	document.addEventListener('DOMContentLoaded', () => {
	const storyTexts = document.querySelectorAll('.stat-text');
	const storyImages = document.querySelectorAll('.stats-images-container figure');

	const observerOptions = {
		root: null, // use the viewport as the root
		threshold: 0.5 // adjust this to trigger the transition when 50% of the story text is visible
	};

	const fadeImage = (index) => {
		storyImages.forEach((image, i) => {
			if (i === index) {
				image.style.opacity = 1;  // fade in the matching image
			} else {
				image.style.opacity = 0;  // fade out all other images
			}
		});
	};

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				const index = Array.from(storyTexts).indexOf(entry.target);
				fadeImage(index);
			}
		});
	}, observerOptions);

	// Initially set opacity for all images to 0 except the first one
	storyImages.forEach((image, index) => {
		image.style.opacity = index === 0 ? 1 : 0;  // Only first image visible on load
		image.style.transition = 'opacity 0.5s ease'; // Add smooth fade transition
	});

	// Observe all story text elements
	storyTexts.forEach(text => observer.observe(text));
	});
}

initCjiStories();

export default initCjiStories;